import { InfoCircleFill } from "react-bootstrap-icons";

interface InfoBoxProps {
    children?: React.ReactNode;
    htmlContent?: string;
    className?: string;
    style?: React.CSSProperties;
    variant?: "default" | "gold";
}

export function InfoBox({ children, htmlContent, className = "", style, variant = "default" }: InfoBoxProps) {
    const defaultStyle = variant === "gold" ? {} : { backgroundColor: 'var(--color-light)' };
    const combinedStyle = { ...defaultStyle, ...style };
    const alertClass = variant === "gold" ? "alert-muted-gold" : "alert-purple";

    return (
        <div 
            className={`alert ${alertClass} my-3 d-flex align-items-start gap-2 ${className}`} 
            style={combinedStyle}
        >
            <InfoCircleFill className="fs-5 flex-shrink-0" />
            {htmlContent ? (
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            ) : (
                children
            )}
        </div>
    );
} 